const images = {};
function importAll(r) {
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
}
importAll(require.context("../images", false, /\.(png|jpe?g|svg)$/));

export default images;
